export const TRY_POLL = "TRY_POLL"
export const TRY_POLL_SUCCESS = "TRY_POLL_SUCCESS"
export const TRY_POLL_CLEAN = "TRY_POLL_CLEAN"
export const TRY_POLL_ERROR = "TRY_POLL_ERROR"
